import BlankTile from './tiles/BlankTile.sprite.js';
import BareTile from './tiles/BareTile.sprite.js';
import SoilTile from './tiles/SoilTile.sprite.js';
import CherryTree from './flora/CherryTree.sprite.js';
import MagnoliaTree from './flora/MagnoliaTree.sprite.js';
import OakTree from './flora/OakTree.sprite.js';
import BlueberryPlant from './flora/BlueberryPlant.sprite.js';
import CatnipPlant from './flora/CatnipPlant.sprite.js';
import StrawberryPlant from './flora/StrawberryPlant.sprite.js';
import SunflowerPlant from './flora/SunflowerPlant.sprite.js';
import SweetPeaPlant from './flora/SweetPeaPlant.sprite.js';
import TomatoPlant from './flora/TomatoPlant.sprite.js';
import WatermelonPlant from './flora/WatermelonPlant.sprite.js';

export default [
    ...BlankTile.ASSETS,
    ...BareTile.ASSETS,
    ...SoilTile.ASSETS,
    ...CherryTree.ASSETS,
    ...MagnoliaTree.ASSETS,
    ...OakTree.ASSETS,
    ...BlueberryPlant.ASSETS,
    ...CatnipPlant.ASSETS,
    ...StrawberryPlant.ASSETS,
    ...SunflowerPlant.ASSETS,
    ...SweetPeaPlant.ASSETS,
    ...TomatoPlant.ASSETS,
    ...WatermelonPlant.ASSETS,
];
